import React, { useContext, useState } from "react";
import { Drawer } from "antd";
import { UserAddOutlined } from "@ant-design/icons";
import { CustomButton } from "..";
import { Bid } from "../../types";
import { AuthContext } from "../../context";
import { PreSalesAgreement } from "./agreement";
import { UploadReceiptForm } from "./upload";
import { LetterOfAuthorization } from "./LOA";
import { WitnessPicker } from "./witness-picker";
import { hooks } from "../../hooks";
import { useIsMutating } from "@tanstack/react-query";
import { useAlert } from "../../context/AlertContext";
import { formatError } from "../../utils";

interface ClaimDrawerProps {
  bid: any;
}

export default function ClaimDrawer(
  props: ClaimDrawerProps
): React.JSX.Element {
  const { bid } = props;
  const [formData, setFormData] = useState({
    agreed: false,
    evidence: null,
    witnesses: [] as string[],
  });
  const { user } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [childrenDrawer, setChildrenDrawer] = useState(false);
  // const [showLOA, setShowLOA] = useState(false);
  const users = hooks.useUsers();
  const isMutating = useIsMutating();

  const isStaff =
    user?.hcm.employmentType?.toLowerCase() === "permanent employee";
  const {
    mutate: claim,
    isSuccess,
    error,
    isError,
    reset,
  } = hooks.useClaimAsset();
  const {
    mutate,
    isSuccess: added,
    error: err,
    isError: failed,
    reset: refresh,
  } = hooks.useTPEvidence();

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    // setShowLOA(false);
  };

  const showChildrenDrawer = () => {
    setChildrenDrawer(true);
  };

  const onChildrenDrawerClose = () => {
    setChildrenDrawer(false);
  };

  const WITNESS_COUNT = 2 as const;

  // const handleGenerateLOA = () => {
  //   if (!formData.agreed || !formData.receipt) {
  //     message.error("Please complete the agreement and upload payment receipt");
  //     return;
  //   }

  //   if (isStaff && formData.witnesses.length !== WITNESS_COUNT) {
  //     message.error(`Please select ${WITNESS_COUNT} witnesses`);
  //     return;
  //   }

  //   // setShowLOA(true);
  //   message.success("Letter of Authorization generated successfully!");
  // };

  const canProceed =
    formData.evidence &&
    (!isStaff || formData.witnesses.length === WITNESS_COUNT);

  function handleClaim() {
    console.table(formData);
    const payload: any = {
      roundId: bid?.round?._id,
      assetId: bid?._id,
      id: bid?.round?._id,
      ...formData,
    };
    if (isStaff) {
      claim(payload);
      return;
    } else {
      mutate(payload);
    }
  }

  const { showAlert } = useAlert();

  if (isSuccess || added) {
    reset();
    refresh();
    showAlert({
      type: "success",
      title: "Success",
      text: "Proof received, We will review shortly",
    });
    onClose();
    // addWitness({ id: bid?._id, witness: formData?.witnesses } as any);
  }

  // if (added) {
  //   refresh();
  //   toast.success("Witness added!");
  // }

  if (isError || failed) {
    reset();
    refresh();
    showAlert({
      type: "error",
      title: "Oop!",
      text: formatError(error || err),
    });
  }

  return (
    <>
      <CustomButton type="primary" onClick={showDrawer}>
        Claim
      </CustomButton>

      {/* First Level Drawer - Agreement & Upload */}
      <Drawer
        title={`Claim ${bid?.title}`}
        placement="right"
        width="50vh"
        closable={true}
        onClose={onClose}
        open={open}
      >
        {isStaff ? (
          <>
            <PreSalesAgreement
              bid={bid}
              formData={formData}
              setFormData={setFormData}
            />
            <div style={{ marginBottom: "24px" }}>
              <CustomButton
                type="default"
                onClick={showChildrenDrawer}
                icon={<UserAddOutlined />}
                block
                size="large"
              >
                Add Witnesses ({formData.witnesses.length}/2)
              </CustomButton>
              <Drawer
                title="Add Witnesses"
                placement="right"
                width="50vh"
                closable={true}
                onClose={onChildrenDrawerClose}
                open={childrenDrawer}
              >
                <WitnessPicker
                  formData={formData}
                  setFormData={setFormData}
                  onClose={onChildrenDrawerClose}
                  users={users}
                />
              </Drawer>
            </div>
          </>
        ) : (
          <>
            {/* <CustomButton
              type="primary"
              onClick={handleGenerateLOA}
              disabled={!canProceed}
              block
              size="large"
              icon={<FileTextOutlined />}
            >
              Generate Letter of Authorization
            </CustomButton>
            <LetterOfAuthorization bid={bid} formData={formData} user={user} />
            <div className={styles.actionButtons}>
              <CustomButton type="primary" size="large" style={{ flex: 1 }}>
                Download LOA
              </CustomButton>
              <CustomButton type="default" size="large" style={{ flex: 1 }}>
                Print LOA
              </CustomButton>
            </div> */}
          </>
        )}
        <UploadReceiptForm formData={formData} setFormData={setFormData} />
        <CustomButton
          type="primary"
          onClick={handleClaim}
          disabled={isStaff ? !formData.agreed && !canProceed : !canProceed}
          loading={!!isMutating}
        >
          Submit
        </CustomButton>
      </Drawer>
    </>
  );
}
